import { cn } from '@utils/cn';

import { Text } from '@ui-component-library/components/Text';
import COLORS from '@ui-component-library/styles/colors';

import type { SummaryProps } from './Summary.types';

const DEFAULT_BACKGROUND = '#faf9f8';

export const Summary = ({ title, items, total, color }: SummaryProps) => {
  const backgroundColor = color ? (COLORS[color] ?? DEFAULT_BACKGROUND) : DEFAULT_BACKGROUND;

  return (
    <div
      className={cn('flex w-full flex-col gap-4 rounded-lg border border-[#e6e6e8] p-4')}
      style={{ backgroundColor }}
    >
      {title && (
        <Text variant="text-base/leading-normal/medium" className="text-charcoal-500">
          {title}
        </Text>
      )}

      {items.map((item) => (
        <div key={item.label} className="flex flex-row items-center justify-between gap-5">
          <Text variant="text-sm/leading-normal/normal" className="text-pebble-500 hyphens-auto">
            {item.label}
          </Text>
          <Text
            variant="text-sm/leading-normal/medium"
            className="text-charcoal-500 text-right whitespace-nowrap"
          >
            {item.value}
          </Text>
        </div>
      ))}

      <div className="flex flex-row justify-between gap-5 border-t border-[#e6e6e8] pt-4">
        <Text variant="text-base/leading-normal/medium" className="text-pebble-500 hyphens-auto">
          {total.label}
        </Text>
        <div className="flex flex-col items-end justify-center">
          <Text
            variant="text-sm/leading-normal/medium"
            className="text-charcoal-500 whitespace-nowrap"
          >
            {total.value}
          </Text>
          {total.subValue && (
            <Text variant="text-2xs/leading-normal/normal" className="text-charcoal-500">
              {total.subValue}
            </Text>
          )}
        </div>
      </div>
    </div>
  );
};
